import { render, staticRenderFns } from "./PublishingInfo.vue?vue&type=template&id=76a6272c&"
import script from "./PublishingInfo.vue?vue&type=script&lang=js&"
export * from "./PublishingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports